/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Coordinates } from './Coordinates';
import type { LocalTime } from './LocalTime';
export type StayOverview = {
    stayId?: number;
    coordinates?: Coordinates;
    siteId?: number;
    fromDate?: number;
    toDate?: number;
    compoundType?: StayOverview.compoundType;
    arrivalTime?: LocalTime;
    comment?: string;
    stayStatus?: StayOverview.stayStatus;
    statusSource?: StayOverview.statusSource;
    statusChannel?: StayOverview.statusChannel;
    statusUpdatedAt?: number;
    statusNote?: string;
    isDirty?: boolean;
};
export namespace StayOverview {
    export enum compoundType {
        HOTEL = 'HOTEL',
        GUESTHOUSE = 'GUESTHOUSE',
        CAMPSITE = 'CAMPSITE',
        FARM = 'FARM',
        PRIVATE_ACCOMMODATION = 'PRIVATE_ACCOMMODATION',
        RV_PITCH = 'RV_PITCH',
        PARKING_LOT = 'PARKING_LOT',
        OTHER = 'OTHER',
    }
    export enum stayStatus {
        PLANNED = 'PLANNED',
        REQUEST_SENT = 'REQUEST_SENT',
        CONFIRMED = 'CONFIRMED',
        DECLINED = 'DECLINED',
        NO_RESPONSE = 'NO_RESPONSE',
        CANCELLED = 'CANCELLED',
        CHANGED = 'CHANGED',
    }
    export enum statusSource {
        APP = 'APP',
        USER = 'USER',
        IMPORTED = 'IMPORTED',
    }
    export enum statusChannel {
        EMAIL_LINK = 'EMAIL_LINK',
        PHONE = 'PHONE',
        DIRECT_PROVIDER = 'DIRECT_PROVIDER',
        WHATSAPP = 'WHATSAPP',
        IN_PERSON = 'IN_PERSON',
        OTHER = 'OTHER',
    }
}
